import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./LogisticPage')

export const LogisticPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/LogisticPage/index.js